import { Dispatch, SetStateAction } from 'react';
import { MdOutlineTableRows, MdShowChart } from 'react-icons/md';
import { Placement, Size } from '../designConstants';
import { Mixpanel, MxE } from '../../utils/mixpanelWrapper';
import { ExclusiveSelectProps, IconSegmentedControlButton } from '../SegmentedControlButton';

interface GraphTableToggleButtonProps extends Omit<
  ExclusiveSelectProps,
  'options' | 'selectedOption' | 'onChange'
> {
  graphView: boolean;
  setGraphView: Dispatch<SetStateAction<boolean>>;
  widgetName: string;
}

export const GraphTableToggleButton = ({
  graphView,
  setGraphView,
  widgetName,
  ...iconSegmentedControlButtonProps
}: GraphTableToggleButtonProps) => (
  <IconSegmentedControlButton
    size={Size.LG}
    tooltipPlacement={Placement.BOTTOM}
    {...iconSegmentedControlButtonProps}
    options={[
      { key: 'showTable', icon: <MdOutlineTableRows />, label: 'Table View' },
      { key: 'showGraph', icon: <MdShowChart />, label: 'Graph View' }
    ]}
    selectedOption={graphView ? 'showGraph' : 'showTable'}
    onChange={() =>
      setGraphView(prev => {
        Mixpanel.track(MxE.GraphOrTableChange, {
          widget: widgetName || 'unknown',
          option_selected: !prev ? 'graph' : 'table'
        });
        return !prev;
      })
    }
  />
);
